<template>
  <MapModal
    :modalNode="modalNode"
    :close="cancel"
    :title="routeInteractionTitle"
    id="routeInteraction"
  >
    <template slot="content">
      <schemeDesignLine
        ref="schemeDesignLine"
        @getPlanGuid="getPlanGuid($event)"
        @getDesignLineGuid="getDesignLineGuid($event)"
      ></schemeDesignLine>

      <div class="positioning">
        <span>定位</span>
        <el-button type="primary" @click="pickPoint">地图选点</el-button>
      </div>
    </template>
    <template slot="foot">
      <div class="foot-operate">
        <el-button type="primary" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" @click="onSubmit">
          绘制
        </el-button>
      </div>
    </template>
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const schemeDesignLine = () => import("./schemeDesignLine.vue");

import { getCrossSectionByLineService } from "@/api/api";
import * as mapWork from "./map.js";

export default {
  name: "routeInteraction",
  components: { MapModal, schemeDesignLine },
  props: ["close"],
  data() {
    return {
      routeInteractionTitle: "绘制横断面",
      modalNode: {
        trafficSimulationAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      position: [], //选点
      planGuid: null,
      designLineGuid: null,
    };
  },
  methods: {
    cancel() {
      mapWork.clearLayer();
      this.close();
    },
    getPlanGuid(data) {
      this.planGuid = data;
    },
    getDesignLineGuid(data) {
      this.designLineGuid = data;
    },
    // 地图选点
    pickPoint() {
      mapWork.createLayer();
      this.position = [];
      mapWork.graphicDotsine.clear();
      mapWork.createCrossSectionPoint();
      mapWork.graphicDotsine.on(mars3d.EventType.drawCreated, (e) => {
        let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
          e.graphic._position_draw
        );
        this.position = [_lng, _lat, _alt];
      });
    },
    // 确定
    onSubmit() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      if (this.position.length === 0) {
        return this.$notify({
          title: "请进行地图选点",
          message: "",
          type: "error",
          duration: 1000,
          offset: 320,
        });
      }
      const params = {
        planGuid: this.planGuid,
        designLineGuid: this.designLineGuid,
        l: this.position[0],
        b: this.position[1],
        h: this.position[2],
      };
      getCrossSectionByLineService(params).then((res) => {
        if (res.data.statusCode !== 500) {
          mapWork.createCrossSection(res.data.data.blhs, res.data.data.stake);
        } else {
          this.position = [];
          mapWork.graphicDotsine.clear();
          return this.$notify({
            title: res.data.errors,
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.positioning {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  font-size: 12px;
  color: #fff;
  span {
    padding-right: 0px;
    padding-left: 7px;
  }
  /deep/ .el-button {
    margin-right: 100px;
    margin-left: 11px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
    border-color: rgba(42, 183, 255, 0.66) !important;
    background-color: rgba(42, 183, 255, 0.66) !important;
  }
}
</style>
